import TableContainer from "Common/TableContainer";
import { SubSection } from "context/BlogContext";
import React, { useMemo } from "react";

interface PreviewTableProps {
  subSection: SubSection;
}

const PreviewTable: React.FC<PreviewTableProps> = ({ subSection }) => {
    
  const filteredHeaders = useMemo(
    () => subSection.attrs?.tableData?.headers?.filter((header: string) => header.trim() !== ""),
    [subSection.attrs.tableData?.headers]
  );

  const filteredRows = useMemo(
    () =>
      subSection.attrs.tableData?.rows?.filter((row: any) =>
        row.some((value: string) => value.trim() !== "")
      ),
    [subSection.attrs.tableData?.rows]
  );

  const previewColumns = useMemo(
    () =>
      filteredHeaders?.map((header: string, columnIndex: number) => ({
        header: (
          <div className="flex flex-col gap-3">
            <span className="font-semibold">{header}</span>
          </div>
        ),
        id: `column-${columnIndex}`,
        accessorKey: `column-${columnIndex}`,
        enableColumnFilter: false,
        cell: (cell: any) => {
          const {
            row: { index },
          } = cell;
          return <div>{filteredRows[index]?.[columnIndex] || "-"}</div>;
        },
      })),
    [filteredHeaders, filteredRows]
  );
  return (
    <div>
      {subSection.type === "table" && (
        <div className="pt-5">
          <TableContainer
            isPagination={false}
            columns={previewColumns || []}
            data={filteredRows}
            customPageSize={10}
            divclassName="overflow-x-auto border border-gray-300 dark:border-zink-500 rounded-lg"
            tableclassName="w-full whitespace-nowrap"
            theadclassName="text-center bg-slate-100 dark:bg-zink-600"
            thclassName="px-3.5 py-2.5 text-center font-semibold text-slate-500 border-b border-slate-200 dark:border-zink-500 dark:text-zink-200"
            tdclassName="px-3.5 py-2.5 border-y text-center border-slate-200 dark:border-zink-500"
            PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
          />
        </div>
      )}
    </div>
  );
};

export default PreviewTable;
